import client from './oc2api';

export type GeneralPopupItem = {
  title: string;
  body: string;
  url: string | undefined;
  image_url: string | undefined;
  conversion_url?: string;
};

export type ScoutPopupItem = {
  company: {
    id: number;
    name: string;
    square_logo: string | undefined;
  };
  url: string;
};

export type EventPopupItemType = 'PR' | 'favorite' | 'industry' | 'other';
export type EventCategory = 'seminar' | 'internship' | 'entry';
type EventDescriptionItem = {
  label: string;
  content: string;
};
export type EventSchedule = {
  id: number;
  title: string;
  start_at: string | undefined;
  end_at: string | undefined;
  time_limit_at: string | undefined;
  place: string;
  has_reached_admission_limit: string;
  stopped_entry: boolean;
  canceled: boolean;
  live_url: string;
};
export type EventCompany = {
  id: number;
  name: string;
  square_logo: string | undefined;
  business_category_id: number;
  business_category_name: string;
};
export type EventPopupItem = {
  item_type: EventPopupItemType;
  event: {
    id: number;
    title: string;
    eye_catch_image_url: string | undefined;
    category: EventCategory;
    has_live_schedule: boolean;
    event_description_items: EventDescriptionItem[];
    schedules: EventSchedule[];
    host_company: EventCompany | undefined;
    companies: EventCompany[];
  };
};

export type PopupData = {
  popup: {
    type: 'general' | 'events' | 'scouts';
    id: string;
    item?: GeneralPopupItem;
    items?: ScoutPopupItem[] | EventPopupItem[];
  };
};

export function fetchPopup() {
  return client
    .get('/api/v1/popup', {
      params: { allowed_types: ['general', 'scouts', 'events'] },
    })
    .then((response) => {
      if (response.status === 204) {
        return undefined;
      } else {
        return response.data as PopupData;
      }
    })
    .catch((_error) => {
      // エラーが起きてもユーザーがサービスを利用し続けられるようにポップアップがなかったとみなす
      // TODO: Sentry にエラー情報を送る
      return undefined;
    });
}

export function readPopup(popupId: string) {
  return client.patch('/api/v1/popup', {
    popup_id: popupId,
  });
}
